import CustomNavbar from "../components/Navbar/CustomNavbar";
import Navbar from "../components/Navbar/Navbar";
import Post from "../components/post/Post";

const PostPage = () => {
    return (  

        <>
        <CustomNavbar/>
        {/* <Navbar/> */}
        <Post/>
        </>
    );
}
 
export default PostPage;